export default __webpack_public_path__ + "a06c1558054edde04b2a931473d334f9.png";